/// <reference path="../../../app.definition.ts" />

import angular from "angular";
import { PostTypeEnums } from "@common/model/_adocument";

interface IEcvFileIcons {
    attachment: any;
    init(): void;
}

class EcvFileIcons implements IEcvFileIcons {
    isImage: boolean;
    extension: string;
    attachment: any;
    extensionNotSupported: boolean;
    isLink: boolean;

    constructor() {
    }


    init(): void {
        this.isLink = (!!this.attachment && this.attachment.postType == PostTypeEnums.LINK)
        this.extension = !!this.attachment && !this.isLink ? this.attachment.extension : '';
        this.isImage = (!!this.attachment && this.attachment.type == 'image') || ['png', 'gif', 'jpg', 'jpeg', 'bmp'].includes(this.extension.toLowerCase());
        if (!this.isImage && !this.isLink && !['pdf', 'xls', 'xlsx', 'doc', 'docx', 'txt', 'rtf', 'ods', 'odt', 'odp', 'zip', 'ppt', 'pptx', 'csv'].includes(this.extension.toLowerCase())) {
            this.extensionNotSupported = true;
        }
    }

}

function fileIcons(): ng.IDirective {
    return {
        restrict: 'E',
        replace: true,
        template: `
                <span>
                    <i class="fa fa-file-pdf-o" ng-if="fileIconsVm.extension == 'pdf'"></i>
                    <i class="fa fa-file-excel-o" ng-if="fileIconsVm.extension == 'xls' || fileIconsVm.extension == 'xlsx'"></i>
                    <i class="fa fa-file-word-o" ng-if="fileIconsVm.extension == 'doc' || fileIconsVm.extension == 'docx'"></i>
                    <i class="fa fa-file-text-o"
                       ng-if="fileIconsVm.extension == 'txt' || fileIconsVm.extension == 'rtf' || fileIconsVm.extension == 'ods' || fileIconsVm.extension == 'odt' || fileIconsVm.extension == 'odp' || fileIconsVm.extension == 'csv'"></i>
                    <i class="fa fa-file-archive-o" ng-if="fileIconsVm.extension == 'zip'"></i>
                    <i class="fa fa-file-powerpoint-o" ng-if="fileIconsVm.extension == 'ppt' || fileIconsVm.extension == 'pptx'"></i>
                    <i class="fa fa-file-image-o" ng-if="fileIconsVm.isImage"></i>
                    <i class="fa fa-video-camera" ng-if="fileIconsVm.isLink"></i>
                    <i class="fa fa-file-o" ng-if="!!fileIconsVm.extensionNotSupported"></i>
                </span>
            `,
        controller: EcvFileIcons,
        controllerAs: 'fileIconsVm',
        bindToController: {
            'attachment': '=ecvAttachment'
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvFileIcons): void => {
            controller.init();
            scope.$watch(() => {
                return !!controller.attachment ? controller.attachment.extension : null;
            }, (newVal, oldVal) => {
                if (!!newVal && newVal != oldVal) {
                    controller.init();
                }
            });
        }
    };
}

angular.module('eCareVault.common.directives').directive('ecvFileIcons', fileIcons);
